export default __webpack_public_path__ + "locales/lv/PrivacyPage.json?hash=423446b9732da7c17b77223b3e2b2cda";